import { Ref } from 'react';
import { useDeleteServiceMutation } from '../queries';
import { ImperativeDialog } from '@shared/components/dialogs/imperative-dialog';
import { ImperativeFormDialogRefType } from '@shared/components/UserFormDialog';
import { useIntlTranslations } from '@libs/intl/intl.hooks';

type DeleteServiceDialogProps = {
  serviceId: string;
  dialogRef: Ref<ImperativeFormDialogRefType | null>;
};

const DeleteServiceDialog = (props: DeleteServiceDialogProps) => {
  const { serviceId, dialogRef } = props;
  const { t } = useIntlTranslations('services');
  const { mutate: deleteServiceMutation } = useDeleteServiceMutation();

  return (
    <ImperativeDialog
      ref={dialogRef}
      onConfirm={() => deleteServiceMutation(serviceId)}
      title={t('deleteService')}
    />
  );
};

export default DeleteServiceDialog;
